export interface HighlightKeywordsQueryVariables {
	pageARI?: string;
	workspaceId: string;
	keywordsEnabled: boolean;
}

export type HighlightKeywordsFromTextFormat = 'ADF' | 'PLAIN';

export interface HighlightKeywordsFromTextQueryVariables {
	inputText: {
		format: HighlightKeywordsFromTextFormat;
		text: string;
	};
	workspaceId: string;
}

export enum KeyPhraseCategory {
	PROJECT = 'PROJECT',
	TEAM = 'TEAM',
	ACRONYM = 'ACRONYM',
	OTHER = 'OTHER',
}

export interface HighlightKeywordsQueryType {
	getKeywords: string[] | null;
	knowledgeDiscovery: {
		keyPhrases: {
			nodes: {
				keyPhrase: string;
				category: KeyPhraseCategory;
			}[];
		};
	};
}

export interface HighlightKeywordsFromTextQueryType {
	knowledgeDiscovery: {
		keyPhrases: {
			nodes: {
				keyPhrase: string;
				category: KeyPhraseCategory;
			}[];
		};
	};
}
